import { db } from "@/firebase/init"

export default {
	namespaced: true,
	state: {
		customer: {
			id: null,
			docID: null,
			firstName: null,
			lastName: null,
			companyName: null,
			ip: null,
			addrLine1: null,
			addrLine2: null,
			city: null,
			state: null,
			postalCode: null,
			affiliateID: null,
			countryName: null,
			countryCode: null,
			language: null,
			email: null,
			twoFA:false,
			twoFAVerified: false,
			welcomeEmailSent: null,
			welcomeEmailAddress: null,
			lastPasswordReset: null,
			refreshFlag: false,
			enableBackupTime: true,
			enableOldBackupProcess: true,
			enableNewBackupProcess: false,
			createdAt: '',
			storageEmailAlerts: true,
		}
	},
	getters: {
		details(state) {
			return state.customer
		},
		id(state) {
			return state.customer.id
		},
		docID(state) {
			return state.customer.docID
		},
		email(state) {
			return state.customer.email
		},
		welcomeEmailSent(state) {
			return state.customer.welcomeEmailSent;
		},
		getLastPasswordReset(state) {
			return state.customer.lastPasswordReset;
		}
	},
	mutations: {
		allDetailsMutate(state, payload) {
			state.customer.id = payload.customerID
			state.customer.docID = payload.docID
			state.customer.firstName = payload.firstName
			state.customer.lastName = payload.lastName
			state.customer.companyName = payload.companyName
			state.customer.ip = payload.ip
			state.customer.addrLine1 = payload.addrLine1
			state.customer.addrLine2 = payload.addrLine2
			state.customer.city = payload.city
			state.customer.state = payload.state
			state.customer.postalCode = payload.postalCode
			state.customer.affiliateID = payload.affiliateID
			state.customer.countryName = payload.countryName
			state.customer.countryCode = payload.countryCode
			state.customer.language = payload.language
			state.customer.email = payload.email
			state.customer.twoFA = payload.twoFA
			state.customer.welcomeEmailSent = payload.welcomeEmailSent
			state.customer.welcomeEmailAddress = payload.welcomeEmailAddress
			state.customer.lastPasswordReset = payload.lastPasswordReset
			state.customer.refreshFlag=payload.refreshFlag || false
			state.customer.uuid = payload.uuid;
			state.customer.createdAt = payload.createdAt;
			state.customer.enableBackupTime = payload.enableBackupTime === undefined ? true : payload.enableBackupTime;
			state.customer.enableOldBackupProcess = payload.enableOldBackupProcess === undefined ? true : payload.enableOldBackupProcess;
			state.customer.enableNewBackupProcess = !!payload.enableNewBackupProcess;
			state.customer.emailSetup = (payload.emailSetupFlag === undefined) ? false : payload.emailSetupFlag;
			state.customer.storageEmailAlerts = (payload.storageEmailAlerts === undefined) ? true : payload.storageEmailAlerts;
			if (state.customer.emailSetup) {
				state.customer.emailUsername = (payload.emailUsernames) ? payload.emailUsernames.username : '';
				state.customer.emailPrimaryDomain = (payload.emailUsernames) ? payload.emailUsernames.domain : '';
			} else {
				state.customer.emailUsername = null;
				state.customer.allEmailDomains = [];
				state.customer.emailAccounts = [];
			}
		},
		fetchDetailsMutate(state, payload) {
			state.customer.id = payload.customerID
			state.customer.docID = payload.docID
			state.customer.firstName = payload.firstName
			state.customer.lastName = payload.lastName
			state.customer.companyName = payload.companyName
			state.customer.ip = payload.ip
			state.customer.addrLine1 = payload.addrLine1
			state.customer.addrLine2 = payload.addrLine2
			state.customer.city = payload.city
			state.customer.state = payload.state
			state.customer.postalCode = payload.postalCode
			state.customer.affiliateID = payload.affiliateID
			state.customer.countryName = payload.countryName
			state.customer.countryCode = payload.countryCode
			state.customer.language = payload.language
			state.customer.email = payload.email
			state.customer.twoFA = payload.twoFA
			state.customer.welcomeEmailSent = payload.welcomeEmailSent
			state.customer.welcomeEmailAddress = payload.welcomeEmailAddress
			state.customer.lastPasswordReset = payload.lastPasswordReset
			state.customer.refreshFlag=payload.refreshFlag || false
			state.customer.storageEmailAlerts = (payload.storageEmailAlerts === undefined) ? true : payload.storageEmailAlerts;
			state.customer.enableBackupTime = payload.enableBackupTime === undefined ? true : payload.enableBackupTime;
			state.customer.enableOldBackupProcess = payload.enableOldBackupProcess === undefined ? true : payload.enableOldBackupProcess;
			state.customer.enableNewBackupProcess = !!payload.enableNewBackupProcess;
		},
		basicDetailsMutate(state, payload) {
			state.customer.firstName = payload.firstName
			state.customer.lastName = payload.lastName
			state.customer.companyName = payload.companyName
			state.customer.ip = payload.ip
			state.customer.addrLine1 = payload.addrLine1
			state.customer.addrLine2 = payload.addrLine2
			state.customer.city = payload.city
			state.customer.state = payload.state
			state.customer.postalCode = payload.postalCode
			state.customer.affiliateID = payload.affiliateID
			state.customer.countryName = payload.countryName
			state.customer.countryCode = payload.countryCode
			state.customer.language = payload.language
			state.customer.refreshFlag=payload.refreshFlag || false
			state.customer.enableBackupTime = payload.enableBackupTime === undefined ? true : payload.enableBackupTime;
			state.customer.enableOldBackupProcess = payload.enableOldBackupProcess === undefined ? true : payload.enableOldBackupProcess;
			state.customer.enableNewBackupProcess = !!payload.enableNewBackupProcess;
			state.customer.emailUsernames=payload.emailUsernames || null
			state.customer.storageEmailAlerts = (payload.storageEmailAlerts === undefined) ? true : payload.storageEmailAlerts;
		},
		userSelfDetailsMutate(state, payload) {
			state.customer.firstName = payload.firstName
			state.customer.lastName = payload.lastName
			state.customer.companyName = payload.companyName
			state.customer.addrLine1 = payload.addrLine1
			state.customer.addrLine2 = payload.addrLine2
			state.customer.city = payload.city
			state.customer.state = payload.state
			state.customer.postalCode = payload.postalCode
			state.customer.countryName = payload.countryName
			state.customer.countryCode = payload.countryCode
			state.customer.refreshFlag=payload.refreshFlag || false
			state.customer.storageEmailAlerts = (payload.storageEmailAlerts === undefined) ? true : payload.storageEmailAlerts;
			state.customer.enableBackupTime = payload.enableBackupTime === undefined ? true : payload.enableBackupTime;
			state.customer.enableOldBackupProcess = payload.enableOldBackupProcess === undefined ? true : payload.enableOldBackupProcess;
			state.customer.enableNewBackupProcess = !!payload.enableNewBackupProcess;
		},
		emailMutate(state, payload) {
			state.customer.email = payload.email
		},
		storageAlertMutate(state, payload) {
			state.customer.storageEmailAlerts = payload.storageEmailAlerts
		},
		welcomeEmailMutate(state, payload) {
			state.customer.welcomeEmailSent = true;
			state.customer.welcomeEmailAddress = payload;
		},
		lastPasswordResetMutate(state, payload) {
			state.customer.lastPasswordReset = payload;
		}
	},
	actions: {
		allDetailsUpdate(context, payload) {
			context.commit('allDetailsMutate', payload)
		},
		basicDetailsUpdate(context, payload) {
			context.commit('basicDetailsMutate', payload)
		},
		emailUpdate(context, payload) {
			context.commit('emailMutate', payload)
		},
		storageAlertUpdate(context, payload) {
			console.log('I was called here?', payload)
			context.commit('storageAlertMutate', payload)
		},
		fetchUser(context) {
			context.dispatch("async/stateUpdate", { state: false }, { root: true })

			db.collection("users").doc(context.rootGetters.getUID).get()
			.then(doc => {
				console.log(doc.data());
				context.commit("fetchDetailsMutate", {
					docID: context.rootGetters.getUID,
					...doc.data()
				})
				context.dispatch("async/stateUpdate", { state: true }, { root: true })
			})
			.catch(err => {
				context.dispatch("async/stateUpdate", { state: true }, { root: true })

				context.dispatch("alert/update", {
					type: "error",
					message: err.message,
					show: true
				}, { root: true })

				setTimeout(() => {
					context.dispatch("alert/showUpdate", {
						show: false
					}, { root: true })
				}, 5000)
			})
		}
	}
}
